import { render, staticRenderFns } from "./lunboTwo.vue?vue&type=template&id=67b74445&scoped=true"
import script from "./lunboTwo.vue?vue&type=script&lang=js"
export * from "./lunboTwo.vue?vue&type=script&lang=js"
import style0 from "./lunboTwo.vue?vue&type=style&index=0&id=67b74445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b74445",
  null
  
)

export default component.exports